import * as React from "react"

import { cn } from "@/custolink-newdesign/lib/utils"

function Input({ className, type, ...props }: React.ComponentProps<"input">) {
  return (
    <input
      type={type}
      data-slot="input"
      className={cn(
        "cl:h-9 cl:w-full cl:min-w-0 cl:rounded-md cl:border cl:border-input cl:bg-transparent cl:px-3 cl:py-1 cl:text-base cl:shadow-xs cl:transition-[color,box-shadow] cl:outline-none cl:selection:bg-primary cl:selection:text-primary-foreground cl:file:inline-flex cl:file:h-7 cl:file:border-0 cl:file:bg-transparent cl:file:text-sm cl:file:font-medium cl:file:text-foreground cl:placeholder:text-muted-foreground cl:disabled:pointer-events-none cl:disabled:cursor-not-allowed cl:disabled:opacity-50 cl:md:text-sm cl:dark:bg-input/30",
        "cl:focus-visible:border-ring cl:focus-visible:ring-[3px] cl:focus-visible:ring-ring/50",
        "cl:aria-invalid:border-destructive cl:aria-invalid:ring-destructive/20 cl:dark:aria-invalid:ring-destructive/40",
        className
      )}
      {...props}
    />
  )
}

export { Input }
